export default {
	// Custom Page Meta
	seo_meta_title_leaguepass: 'League Pass - Streaming NBA in diretta | NBA.com',
	seo_meta_desc_leaguepass: 'Guarda in streaming le partite NBA in diretta e on-demand con League Pass. Accedi al tuo account qui.',
	seo_meta_keywords_leaguepass: 'Video NBA, highlight NBA, spettacolari, video di basket, azioni più spettacolari, schiacciate',
	seo_meta_title_featured: 'Guarda le partite NBA in streaming e tutti gli highlights | NBA.com',
	seo_meta_desc_featured: 'Accedi gratuitamente a highlights NBA, notizie e analisi.  Scopri tutti gli abbonamenti NBA TV e League Pass per guardare le partite in diretta sui tuoi dispositivi preferiti.',
	seo_meta_keywords_featured: '',
	seo_meta_title_nbatv: 'NBA TV - Streaming di giochi dal vivo e copertura 24 ore su 24 | NBA.com',
	seo_meta_desc_nbatv: 'Guarda le partite NBA TV in diretta via streaming o le partite storiche on-demand. Accedi inoltre a programmi esclusivi in studio e analisi del campionato.',
	seo_meta_keywords_nbatv: 'Canale TV dell’NBA, partite NBA, the beat, partite storiche, hardwood classics, nba in diretta, partite nba, fantasy game, the jump',
	seo_meta_title_classicgames: 'Guarda le partite storiche e molto altro con NBA TV | NBA.com',
	seo_meta_desc_classicgames: 'Guarda le partite NBA che hanno fatto la storia con NBA TV e accedi alle partite NBA TV in diretta streaming, oltre a programmi in studio e analisi di tutto il campionato.',
	seo_meta_keywords_classicgames: '',
	seo_meta_pre_title_videolist: 'Guarda in streaming qui | NBA.com',
	seo_meta_title_videolist: 'Guarda in streaming {0} qui | NBA.com',
	seo_meta_desc_videolist: 'Guarda i video {0} qui. Scopri inoltre gli abbonamenti NBA TV e League Pass per guardare le partite in diretta sui tuoi dispositivi preferiti.',
	seo_meta_title_videolist_show: 'Guarda {0} in streaming con NBA TV | NBA.com',
	seo_meta_desc_videolist_show: 'Guarda {0} qui. Inoltre, non perderti le partite NBA TV in diretta e accedi ad analisi e partite storiche.',
	seo_meta_keywords_videolist_show: '',
	seo_meta_title_videolist_feed: 'Guarda {0} in streaming qui | NBA.com',
	seo_meta_desc_videolist_feed: 'Guarda i video {0} qui. Scopri inoltre gli abbonamenti NBA TV e League Pass per guardare le partite in diretta sui tuoi dispositivi preferiti.',
	seo_meta_keywords_videolist_feed: '',
	seo_meta_keywords_videolist: '',
	seo_meta_title_shows: 'Ultime dallo studio in streaming e molto altro con NBA TV | NBA.com',
	seo_meta_desc_shows: 'Esplora e guarda i programmi NBA TV in streaming e on-demand. Accesso alle partite NBA TV in diretta, oltre alle partite storiche dell\'NBA e alle analisi in studio.',
	seo_meta_keywords_shows: '',
	// Common Page Meta
	seo_meta_title_home: 'Home | NBA.com',
	seo_meta_desc_home: '',
	seo_meta_keywords_home: '',
	seo_meta_title_channels: 'Canali | NBA.com',
	seo_meta_desc_channels: '',
	seo_meta_keywords_channels: '',
	seo_meta_pre_title_channel: 'Canale | NBA.com',
	seo_meta_pre_title_categories: 'Categorie | NBA.com',
	seo_meta_title_categories: 'Categorie | NBA.com',
	seo_meta_desc_categories: '',
	seo_meta_keywords_categories: '',
	seo_meta_pre_title_category: 'Categoria | NBA.com',
	seo_meta_title_category: 'Categoria | NBA.com',
	seo_meta_desc_category: '',
	seo_meta_keywords_category: '',
	seo_meta_pre_title_video: 'Guarda in streaming qui | NBA.com',
	seo_meta_pre_title_event: 'Guarda l\'evento in streaming qui | NBA.com',
	seo_meta_title_events: 'Eventi | NBA.com',
	seo_meta_desc_events: '',
	seo_meta_keywords_events: '',
	seo_meta_title_event: 'Guarda {0} in streaming qui | NBA.com',
	seo_meta_desc_event: 'Guarda {0} qui. Scopri inoltre gli abbonamenti NBA TV e League Pass per guardare le partite in diretta sui tuoi dispositivi preferiti.',
	seo_meta_keywords_event: '',
	seo_meta_title_search: 'Cerca | NBA.com',
	seo_meta_desc_search: '',
	seo_meta_keywords_search: '',
	seo_meta_title_notfound: 'Pagina non trovata | NBA.com',
	seo_meta_desc_notfound: '',
	seo_meta_keywords_notfound: '',
	seo_meta_pre_title_game: 'Guarda la partita in streaming qui | NBA.com',
	seo_meta_title_game: 'Guarda {0} in streaming  qui | NBA.com',
	seo_meta_desc_game: 'Guarda {0} qui. Scopri inoltre gli abbonamenti NBA TV e League Pass per guardare le partite in diretta sui tuoi dispositivi preferiti.',
	seo_meta_keywords_game: '',
	seo_meta_title_video: 'Trasmetti in streaming {0} qui | NBA.com',
	seo_meta_desc_video: 'Guarda {0} qui. Inoltre, esplora gli abbonamenti NBA TV e League Pass per guardare le partite in diretta sui tuoi dispositivi preferiti.',
	seo_meta_keywords_video: 'Video NBA, highlight NBA, spettacolari, video di basket, azioni più spettacolari, schiacciate',
	seo_meta_title_episode: 'Guarda {0} in streaming con NBA TV | NBA.com',
	seo_meta_desc_episode: 'Guarda {0} qui. Scopri inoltre gli abbonamenti NBA TV e League Pass per guardare le partite in diretta sui tuoi dispositivi preferiti.',
	seo_meta_keywords_episode: 'Video NBA, highlight NBA, spettacolari, video di basket, azioni più spettacolari, schiacciate',
	seo_meta_title_channel: 'NBA TV Live | NBA.com',
	seo_meta_desc_channel: 'NBA TV Live è il tuo canale TV dell’NBA in diretta streaming, che ogni settimana ti offre 24 ore su 24 partite NBA in diretta, repliche, programmi in studio e analisi degli opinionisti',
	seo_meta_keywords_channel: 'Canale TV dell’NBA, partite NBA, the beat, partite storiche, hardwood classics, nba in diretta, partite nba, fantasy game, the jump',
	seo_meta_title_tvguide: 'Calendario dirette streaming NBA TV | NBA.com',
	seo_meta_desc_tvguide: 'Scopri quando saranno disponibili le dirette streaming e i programmi NBA TV per guardarli suoi tuoi dispositivi preferiti. Avrai inoltre accesso a interviste e analisi in studio on-demand.',
	seo_meta_keywords_tvguide: 'Canale TV dell’NBA, partite NBA, the beat, partite storiche, hardwood classics, nba in diretta, partite nba, fantasy game, the jump',

	// Common
	timezone: 'ET',
	default_feed_error_message: 'Qualcosa è andato storto, il contenuto non è disponibile. Riprova.',
	watch_in_app: 'GUARDA SULL\'APP NBA',
	ad_blocked_message: 'Rilevato blocco pubblicità: i contenuti di NBA.com sono supportati dalla pubblicità. Per continuare a usufruire dei nostri contenuti, disattiva il blocco degli annunci.',

	// Item
	no_content: 'Nessun contenuto',
	see_more: 'Vedi altri contenuti',
	now_playing: 'IN RIPRODUZIONE',
	nba_tv_lock: 'NBA TV',
	league_pass_lock: 'League Pass',
	league_pass_premium_lock: 'LP PREMIUM',
	error_max_limit_favorite: 'Hai raggiunto il numero massimo di video preferiti che puoi selezionare. Se desideri aggiungerne un altro, rimuovi uno di quelli già selezionati.',
	item_live: 'In diretta:',
	add_favourite_title: 'AGGIUNGI AI PREFERITI',
	remove_favourite_title: 'RIMUOVI DAI PREFERITI',
	// Channel: Schedule
	p_channel_live: 'In diretta:',
	p_channel_schedule_title: 'Palinsesto NBA TV',
	p_channel_schedule_watch: 'Guarda',
	p_channel_live24x7_title: 'NBA TV 24H',
	p_channel_live24x7_see_full_schedule: 'Vedi palinsesto completo',
	p_channel_live24x7_up_next: 'Prossimo programma',
	p_channel_live24x7_on_demand: 'NBA TV: On-Demand',
	p_channel_live24x7_collection: 'Collezione',
	p_channel_live24x7_demand_1_logo_text: 'Programmi originali',
	p_channel_live24x7_demand_1_show_name: 'Programmi NBA TV',
	p_channel_live24x7_demand_1_show_desc: 'Programmi esclusivi NBA TV tra cui Shaqtin \'a Fool, Beyond the Paint, Game Time e Basketball Stories',
	p_channel_live24x7_demand_2_logo_text: 'Classic Games',
	p_channel_live24x7_demand_2_show_name: 'NBA | Partite classiche',
	p_channel_live24x7_demand_2_show_desc: 'Guarda le partite storiche in versione integrale, inclusi tutti gli incontri delle Finals dal 2000, i momenti storici del campionato e le leggende dell\'NBA',

	// Channel: Clips
	p_channel_error_msg: 'Non ancora disponibile',

	// Channel: detail
	p_channel_category_title: 'NBA TV',
	p_channel_playlist_title: 'Programmazione',

	// NBA TV Shows:
	p_nba_tv_shows: 'Programmi NBA TV',
	p_nba_tv_no_access_title: 'NBA 24 ore su 24, 7 giorni su 7: tieniti informato con analisi di partita, commenti in studio,  programmi esclusivi e molto altro!',
	p_nba_tv_no_access_desc: 'Guarda le partite in diretta più i programmi e le partite storiche on-demand.',
	p_nba_tv_no_access_note: 'Alcune tramissioni possono essere oscurate',

	// tv show item
	tv_show_item_latest_episode: 'episodio più recente',
	tv_show_item_no_latest_episode: 'nessun episodio più recente',
	see_all: 'Vedi tutto',
	// header
	header_menu_watch: 'Guarda',
	header_menu_featured: 'IN PRIMO PIANO',
	header_menu_nba_tv: 'NBA TV',
	header_menu_league_pass: 'League Pass',

	// search
	players: 'Giocatori',
	videos: 'Video',
	teams: 'Squadre',
	most_searched: 'PIÙ CERCATO',
	no_result: 'Nessun dato',
	search_filter_type_most_relevant: 'Più rilevanti',
	search_filter_type_most_viewed: 'I più visti',
	search_filter_type_most_recent: 'I piu recenti',
	search_filter_type_last_30_days: 'Ultimi 30 giorni',
	search_filter_type_last_6_months: 'Ultimi 6 mesi',
	search_result_label: 'Risultati di ricerca per \'{keyword}\'',
	search_result_info: 'Visualizza tutti i risultati per {keyword}',
	search_placeholder: 'Cerca nella libreria video',
	load_more: 'Carica altro...',

	// button
	button_subscribe: 'Iscriviti',
	button_sign_in: 'Accedi',
	button_tv_provider: 'Seleziona provider TV',

	// league page
	p_league_pass_no_access_title: 'Guarda le partite in diretta o in differita su qualsiasi dispositivo, inclusi computer, smartphone e TV!',
	p_league_pass_no_access_desc: 'Il tuo biglietto per l\'azione NBA: guarda tutto il campionato o la tua squadra preferita, scegli una singola partita o scopri tutti i pacchetti.',
	p_league_pass_no_access_note: 'Si applicano termini',

	// Video
	category_title: 'Video',
	p_video_playlist_title: 'Playlist:',
	p_video_episode_text: 'Episodio',
	p_no_access_league_pass_title: 'Sblocca NBA League Pass per guardare:',
	p_no_access_league_pass_premium_title: 'Unlock NBA League Pass Premium to watch:',
	p_no_access_league_pass_desc: 'Il tuo biglietto per l\'azione NBA: guarda tutto il campionato o la tua squadra preferita, scegli una singola partita o scopri tutti i pacchetti.',
	p_no_access_league_pass_terms: 'Si applicano termini',
	p_no_access_league_pass_geo_desc: 'In base alla tua posizione attuale, non puoi visualizzare questa partita tramite NBA League Pass e NBA TV. La versione archiviata di questa partita sarà disponibile 3 giorni dopo la trasmissione per gli abbonati a NBA League Pass. Vedi i palinsesti delle tue emittenti radiofoniche e televisive locali per sapere dove poter vedere o ascoltare questa partita nel tuo paese.',
	p_no_access_league_pass_not_found_desc: 'La pagina richiesta non è stata trovata.',
	p_no_access_event_geo_desc: 'Questa trasmissione non è disponibile per i fan negli Stati Uniti e in Canada. Per guardare questo evento, sintonizzati su ESPN negli Stati Uniti e TSN o Sportsnet in Canada.',
	p_no_access_event_not_found_desc: 'L\'evento richiesto non è stato trovato.',
	p_no_access_nba_tv_title: 'Sblocca NBA TV per guardare:',
	p_no_access_nba_tv_desc: 'Guarda le partite in diretta più programmi e partite storiche on-demand.',
	p_no_access_nba_tv_terms: 'Si applicano termini',
	p_no_access_nba_tv_geo_desc: 'In base alla tua posizione attuale, non puoi visualizzare questa partita tramite NBA League Pass e NBA TV. La versione archiviata di questa partita sarà disponibile 3 giorni dopo la trasmissione per gli abbonati a NBA League Pass. Vedi i palinsesti delle tue emittenti radiofoniche e televisive locali per sapere dove poter vedere o ascoltare questa partita nel tuo paese.',
	p_no_access_nba_tv_not_found_desc: 'La pagina richiesta non è stata trovata.',
	p_no_access_up_next: 'Prossimo programma:',
	p_video_completed_title: 'Playlist completa',
	p_video_completed_desc: 'Torna indietro per sfogliare o scopri la playlist successiva personalizzata per te',
	p_video_share_to: 'Condividi:',
	p_video_more_to_watch: 'Altri contenuti da guardare:',

	// Event
	p_event_section_title: 'EVENTO',
	p_event_playlist_title: 'Playlist:',
	p_event_button_watch: 'Guarda',
	p_event_button_listen: 'Ascolta',
	p_event_button_ticket: 'Biglietto',

	// notfound page
	notfound: 'La pagina richiesta non è stata trovata.',
	notfound_desc: 'Verifica la correttezza dell\'URL.<br/> Per trovare  il contenuto desiderato, puoi anche provare a utilizzare la navigazione del sito o la funzione di ricerca.',

	// Modal - PCM
	modal_pcm_header_title: '',
	modal_pcm_body_title: '',
	modal_pcm_body_description: 'Il tuo account NBA League Pass ha raggiunto il limite massimo di streaming. Tocca \'Continua\' per riprendere la visione su questo dispositivo.',
	modal_pcm_custom: 'Continua',
	modal_pcm_close: 'Annulla',
	modal_pcm_ok: 'OK',

	// Modal - Unsupported
	modal_video_unsupported_header_title: '',
	modal_video_unsupported_body_title: '',
	modal_video_unsupported_body_description: 'Questo video non può essere riprodotto sul tuo dispositivo. Fai clic <a href=\'https://neulion-a.akamaihd.net/nlweb/h5support/player.html\' target=\'_blank\'>QUI</a> per ricevere ulteriore assistenza.',
	modal_video_unsupported_custom: '',
	modal_video_unsupported_close: 'OK',
	modal_video_unsupported_ok: 'OK',

	// FreeSample
	freesample_notice_time: 'Tempo rimanente',
	freesample_notice_title: 'Goditi i tuoi {0} minuti di accesso',
	freesample_notice_desc: 'Abbonati al pacchetto completo League Pass per continuare ad accedere ai contenuti allo scadere dei {0} minuti.',
	freesample_notice_subscribe_button: 'Iscriviti',
	freesample_notice_cancel_button: 'Annulla in qualsiasi momento',
	freesample_popup_title: 'IL TEMPO A TUA DISPOSIZIONE È TERMINATO',
	freesample_popup_subtitle: 'Abbonati a League Pass per guardare contenuti della NBA ancora più straordinari.',
	freesample_popup_link: 'ULTERIORI INFORMAZIONI',
	freesample_popup_get_minutes_button: 'RICEVI {0}  MINUTI',

	// Video list
	reg_required_desc: 'Devi accedere per visualizzare questo contenuto',
	favorite_teams_title: 'Squadre preferite',
	bookmarked_title: 'Salvato',
	watch_history_title: 'Continua a guardare',
	game_schedule_title: 'Programmazione delle partite',
	recommended_title: 'Consigliato',
	season_text: 'Stagione',

	// profile page
	section_information_title: 'Le mie informazioni',
	section_information_desc: 'Aggiorna le tue informazioni personali',
	section_information_email: 'E-mail',
	section_information_email_update: 'Aggiorna l\'indirizzo email',
	section_information_password: 'Password',
	section_information_password_update: 'Modifica password',
	section_information_social: 'Connessioni a social network',
	section_information_nosocial_message: 'Non disponi di account collegati.',
	section_information_firstname: 'Nome',
	section_information_lastname: 'Cognome',
	section_information_birth: 'Data di nascita',
	section_information_country: 'Paese/Regione',
	section_information_postalcode: 'Codice postale',
	section_information_edit: 'Modifica',
	section_tv_provider_title: 'Il mio provider TV',
	section_tv_provider_desc: 'Ottieni l\'accesso a partite e streaming in diretta con il tuo provider TV.',
	section_tv_provider_faq: 'Domande frequenti sui provider TV',
	section_tv_provider_sign_out: 'Esci',
	section_tv_provider_sign_in: 'Accedi al tuo Provider TV',
	section_fantasy_title: 'Fantabasket',
	section_fantasy_desc: 'Visualizza le informazioni del tuo account fantasy',
	section_fantasy_displayname: 'Nome utente',
	section_marketing_title: 'Le mie preferenze email',
	section_marketing_desc: 'Visualizza le tue preferenze relative a comunicazioni di marketing e privacy',
	section_marketing_newsletters: 'Newsletter',
	section_marketing_message: 'Messaggi e pubblicità NBA',
	section_marketing_newsletters_desc_1: 'News NBA inviate tutti i giorni al tuo indirizzo e-mail',
	section_marketing_newsletters_desc_2: 'News e funzionalità NBA G League, la lega minore ufficiale dell\'NBA',
	section_marketing_newsletters_desc_3: 'News e contenuti NBA Jr., l\'iniziativa di basket giovanile dell\'NBA',
	section_marketing_newsletters_desc_4: 'News sugli aggiornamenti e nuove funzionalità dell\'app NBA, oltre ad aggiornamenti e offerte League Pass',
	section_marketing_newsletters_desc_5: 'Offerte speciali su biglietti, offerte dei partner, eventi e sconti sul merchandise NBA',
	section_marketing_newsletters_desc_6: 'News e contenuti NBA selezionati accuratamente dalla redazione NBA e inviati ogni settimana al tuo indirizzo e-mail',
	section_marketing_newsletters_desc_7: 'News e offerte di WNBA e dei suoi partner.',
	section_marketing_personal_title: 'I miei dati personali',
	section_marketing_personal_desc: 'Acconsento al trattamento delle mie informazioni personali da parte di NBA per inviarmi messaggi e annunci pubblicitari relativi ai prodotti e alle iniziative NBA e dei partner NBA.',
	section_marketing_update_button: 'Aggiorna preferenze di marketing',
	section_marketing_update_success: 'Le tue preferenze sono state aggiornate.',
	section_ccpa_title: 'Non vendere le mie informazioni personali',

	// profile edit modal
	email_modal_title: 'aggiorna l\'indirizzo e-mail',
	email_modal_new_email_label: 'nuovo indirizzo e-mail',
	email_modal_update: 'Aggiorna',
	email_modal_cancel: 'Annulla',
	password_modal_title: 'Modifica password',
	password_modal_current_label: 'Password corrente:',
	password_modal_new_label: 'Nuova password:',
	password_modal_confirm_label: 'Conferma password',
	password_modal_update: 'Aggiorna',
	password_modal_cancel: 'Annulla',
	personal_modal_title: 'aggiorna le informazioni personali',
	personal_modal_email: 'E-mail',
	personal_modal_password: 'Password',
	personal_modal_birth: 'Data di nascita',
	personal_modal_social: 'Connessioni a social network',
	personal_modal_firstname: 'Nome',
	personal_modal_lastname: 'Cognome',
	personal_modal_country: 'Paese/Regione',
	personal_modal_postalcode: 'Codice postale',
	personal_modal_zipcode: 'CAP',
	personal_modal_postalcode_invalid_message: 'Deve essere un codice postale valido',
	personal_modal_zipcode_invalid_message: 'Deve essere un codice postale valido',
	personal_modal_update: 'Aggiorna',
	personal_modal_cancel: 'Annulla',

	// payflow
	payflow_profile_name: 'Nome',
	payflow_profile_email: 'E-mail',

	// account page
	header_menu_account_my_account: 'Il mio account',
	header_menu_account_manage_account: 'Gestisci account',
	header_menu_account_favorite_teams: 'Squadra preferita',
	header_menu_account_favorite_players: 'I miei giocatori preferiti',
	header_menu_account_viewing_history: 'Cronologia',
};
